import React, { useEffect, useState } from "react";
import { NavLink, useParams } from "react-router-dom";
import {  ChevronRight } from "lucide-react";
import { listEntriesBySection } from "../lib/entriesApi";
import { listSections } from "../lib/sectionsApi";

export default function SectionPage() {
  const { sectionSlug } = useParams();

  const [section, setSection] = useState(null);
  const [entries, setEntries] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let alive = true;

    (async () => {
      setLoading(true);

      try {
        const [sections, sectionEntries] = await Promise.all([
          listSections(),
          listEntriesBySection(sectionSlug),
        ]);

        if (!alive) return;

        const currentSection =
          sections.find((s) => s.slug === sectionSlug) || null;

        setSection(currentSection);
        setEntries(sectionEntries || []);
      } catch (e) {
        console.error("Errore caricando sezione:", e);
        if (!alive) return;
        setSection(null);
        setEntries([]);
      } finally {
        if (alive) setLoading(false);
      }
    })();

    return () => {
      alive = false;
    };
  }, [sectionSlug]);

  if (loading) {
    return (
      <main className="mx-auto w-[min(1280px,94%)] py-12">
        <div className="rounded-[32px] border border-slate-200/80 bg-white/80 p-8 shadow-[0_18px_60px_rgba(15,23,42,.07)] backdrop-blur-xl">
          <div className="text-sm font-bold text-slate-500">Caricamento sezione...</div>
        </div>
      </main>
    );
  }

  if (!section) {
    return (
      <main className="mx-auto w-[min(1280px,94%)] py-12">
        <div className="rounded-[32px] border border-slate-200 bg-white p-8 shadow-[0_18px_60px_rgba(15,23,42,.05)]">
          <h1 className="text-3xl font-black text-slate-900">Sezione non trovata</h1>
          <p className="mt-2 text-sm font-semibold text-slate-500">
            La sezione richiesta non esiste oppure non è visibile.
          </p>
        </div>
      </main>
    );
  }

  return (
<main className="mx-auto w-[min(1280px,94%)] pt-28 pb-10 sm:pt-32 sm:pb-12">      <header className="relative mb-8 overflow-hidden rounded-[32px] border border-slate-200/80 bg-white/80 p-6 shadow-[0_18px_60px_rgba(2,6,23,.06)] backdrop-blur-xl sm:p-8 lg:p-10">
        <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(900px_320px_at_0%_0%,rgba(204,58,33,.10),transparent_60%),radial-gradient(700px_280px_at_100%_100%,rgba(251,191,36,.07),transparent_58%),linear-gradient(180deg,rgba(255,255,255,.60),rgba(248,250,252,.88))]" />
        <div className="pointer-events-none absolute inset-x-0 top-0 h-1 bg-[linear-gradient(90deg,#CC3A21,#E58E7C,#F2C9A5)]" />

        <div className="relative">
          <div className="mb-5 flex flex-wrap items-center justify-between gap-3">
            

            
          </div>

          

          <h1 className="mt-4 text-4xl font-black tracking-tight text-slate-900 sm:text-5xl">
            {section.label}
          </h1>

         
        </div>
      </header>

      {entries.length === 0 ? (
        <div className="rounded-[30px] border border-slate-200 bg-white p-8 shadow-[0_18px_60px_rgba(2,6,23,.06)]">
          <div className="text-lg font-black text-slate-900">Nessuna card presente</div>
          <div className="mt-2 text-sm font-semibold text-slate-500">
            In questa sezione non ci sono ancora contenuti.
          </div>
        </div>
      ) : (
        <div className="grid gap-6 sm:grid-cols-2 xl:grid-cols-3">
          {entries.map((entry) => {
            const totalImages = Array.isArray(entry.images)
              ? entry.images.length + (entry.coverUrl ? 1 : 0)
              : entry.coverUrl
              ? 1
              : 0;

            return (
              <NavLink
                key={entry.slug}
                to={`/${section.slug}/${entry.slug}`}
                className="group relative overflow-hidden rounded-[30px] border border-slate-200/80 bg-white shadow-[0_18px_60px_rgba(2,6,23,.08)] transition hover:-translate-y-[2px] hover:shadow-[0_24px_80px_rgba(2,6,23,.12)]"
              >
                <div className="absolute inset-x-0 top-0 z-10 h-1 bg-[linear-gradient(90deg,#CC3A21,#E58E7C,#F2C9A5)] opacity-0 transition group-hover:opacity-100" />

                <div className="relative">
                  {entry.coverUrl ? (
                    <div className="relative h-64 w-full overflow-hidden bg-slate-100">
                      <img
                        src={entry.coverUrl}
                        alt={entry.titolo}
                        className="absolute inset-0 h-full w-full scale-105 object-cover blur-xl opacity-25"
                        loading="lazy"
                        aria-hidden="true"
                      />
                      <img
                        src={entry.coverUrl}
                        alt={entry.titolo}
                        className="relative h-full w-full object-cover transition duration-500 group-hover:scale-[1.03]"
                        loading="lazy"
                      />
                      <div className="absolute inset-0 bg-gradient-to-t from-slate-950/35 via-transparent to-transparent" />
                    </div>
                  ) : (
                    <div className="relative h-64 w-full overflow-hidden bg-slate-100">
                      <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_left,rgba(204,58,33,.10),transparent_35%),radial-gradient(circle_at_bottom_right,rgba(251,191,36,.08),transparent_40%)]" />
                    </div>
                  )}

                  <div className="absolute bottom-3 left-3">
                    <div className="rounded-full border border-white/20 bg-black/45 px-3 py-1.5 text-[11px] font-black uppercase tracking-[0.14em] text-white backdrop-blur-md">
                      {totalImages} immagini
                    </div>
                  </div>
                </div>

                <div className="p-5">
                  <div className="inline-flex items-center rounded-full border border-[#CC3A21]/15 bg-[#CC3A21]/[0.06] px-3 py-1 text-[11px] font-black uppercase tracking-[0.14em] text-[#7A2417]">
                    {section.label}
                  </div>

                  <h2 className="mt-3 text-lg font-black tracking-tight text-slate-900">
                    {entry.titolo || entry.slug}
                  </h2>

                  {entry.descrizione ? (
                    <p className="mt-2 line-clamp-3 text-sm font-semibold leading-relaxed text-slate-600">
                      {entry.descrizione}
                    </p>
                  ) : null}

                  <div className="mt-5 inline-flex items-center gap-2 text-sm font-black text-[#CC3A21] transition group-hover:translate-x-[2px]">
                    Apri contenuto
                    <ChevronRight className="h-4 w-4" />
                  </div>
                </div>
              </NavLink>
            );
          })}
        </div>
      )}
    </main>
  );
}